function cleanElementId(id) {
  return id?.replace(/\s+/g, "").trim();
}

function getSectionRoot(el) {
  return el.closest("[data-section-id]");
}
function getProductData(sectionEl) {
  const sectionId = sectionEl?.getAttribute("data-section-id");
  const bySection = sectionEl?.querySelector(`#ProductJson-${sectionId}`);
  const byProductId = sectionEl?.querySelector('[id^="ProductJSON-"]');
  const el = bySection || byProductId;
  let product = null;
  try {
    product = el ? JSON.parse(el.textContent) : null;
  } catch (e) {}
  return { product, sectionId, sectionEl };
}
function findVariantById(product, id) {
  if (!product || !product.variants) return null;
  const n = Number(id);
  return product.variants.find((v) => Number(v.id) === n) || null;
}
function formatMoney(cents) {
  if (cents == null) return "";

  const currency = window.Shopify?.currency?.active || "USD";
  const amount = Number(cents) / 100;

  // 根据currency_code_enabled配置决定是否显示货币代码
  const currencyCodeEnabled = window.FoxTheme?.settings?.currencyCodeEnabled;

  try {
    const formatted = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(amount);

    // 如果启用了货币代码显示，确保货币代码存在
    if (currencyCodeEnabled && !formatted.includes(currency)) {
      return `${formatted} ${currency}`;
    }

    return formatted;
  } catch {
    const fallback = `$${amount.toFixed(2)}`;
    return currencyCodeEnabled ? `${fallback} ${currency}` : fallback;
  }
}

if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }
      get productId() {
        return this.getAttribute("data-product-id");
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }
      get quantityInput() {
        return this.querySelector("quantity-input input");
      }

      connectedCallback() {
        if (this.shouldWaitForPreGrouping()) {
          this.waitForPreGroupingAndInitialize();
        } else {
          this.initializeProductInfo();
        }
      }

      shouldWaitForPreGrouping() {
        return (
          window.productMediaPreGrouping &&
          !window.productMediaPreGrouping.isInitialized
        );
      }

      async waitForPreGroupingAndInitialize() {
        const waitForPreGrouping = () => {
          return new Promise((resolve) => {
            if (
              window.productMediaPreGrouping &&
              window.productMediaPreGrouping.isInitialized
            ) {
              resolve();
              return;
            }

            const handleInitializationComplete = (event) => {
              document.removeEventListener(
                "productMediaPreGroupingInitialized",
                handleInitializationComplete
              );
              resolve();
            };

            document.addEventListener(
              "productMediaPreGroupingInitialized",
              handleInitializationComplete
            );

            setTimeout(() => {
              document.removeEventListener(
                "productMediaPreGroupingInitialized",
                handleInitializationComplete
              );
              resolve();
            }, 10000);
          });
        };

        await waitForPreGrouping();
        this.initializeProductInfo();
      }

      initializeProductInfo() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        const productData = this.getProcessedProductData();
        this.productJson = productData.product || null;

        this.currentVariant =
          this.getSelectedVariant(this) || this.getInitialVariant();
        // console.log(
        //   "currentVariantcurrentVariantcurrentVariant",
        //   this.currentVariant
        // );
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
          this.renderPrice(this.currentVariant);
          this.renderBuyButton(this.currentVariant);
          this.syncVariantId(this.currentVariant?.id);
        } else {
          const mediaGallery = document.querySelector("media-gallery");
          if (!mediaGallery) {
            return;
          }
          // mediaGallery.style.display = "block";
          mediaGallery.style.opacity = "1";
        }

        this.bindTotalsListeners();
        document.addEventListener("variant:changed", (e) => {
          if (!e?.detail?.variant) return;
          this.currentVariant = e.detail.variant;
          this.renderPrice(this.currentVariant);
          this.renderBuyButton(this.currentVariant);
          this.syncVariantId(this.currentVariant?.id);
        });
      }

      getProcessedProductData() {
        if (
          window.productMediaPreGrouping &&
          window.productMediaPreGrouping.isInitialized
        ) {
          const processedData =
            window.productMediaPreGrouping.getProcessedProductData();
          if (processedData) {
            return processedData;
          }
        }

        return getProductData(this);
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber && this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((_) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) {
          return;
        }
        let clickedOptionIndex = this.getClickedOptionIndex(event?.target);
        if (
          clickedOptionIndex === -1 &&
          this.lastClickedOptionIndex !== undefined &&
          this.lastClickedOptionIndex >= 0
        ) {
          clickedOptionIndex = this.lastClickedOptionIndex;
        }
        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || "main-product";
        this.lastClickedOptionIndex = clickedOptionIndex;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode),
        });
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const quickView = html.querySelector(
            "#MainProduct-quick-view__content"
          );
          if (quickView && viewMode === "quick-view") {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById("shopify-section-sticky-atc-bar"),
              html.getElementById("shopify-section-sticky-atc-bar"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            setTimeout(() => {
              const main = document.querySelector("main#MainContent");
              if (main) {
                const allSections = document.querySelectorAll(
                  '[id^="shopify-section-"]'
                );
                let movedCount = 0;
                const sectionsToMove = []; // 收集需要移动的 sections
                allSections.forEach((section) => {
                  const sectionId = section.id;
                  const isInMain = main.contains(section);
                  // console.log(
                  //   `[DEBUG product-info.js] Section ${sectionId} 在 main 内:`,
                  //   isInMain
                  // );
                  const shouldExclude =
                    sectionId.includes("sticky-atc-bar") ||
                    section.closest('[id^="shopify-section-overlay"]') ||
                    section.closest("overlay-group") ||
                    sectionId.includes("header") ||
                    sectionId.includes("footer") ||
                    sectionId.includes("cart-drawer") ||
                    sectionId.includes("search-drawer") ||
                    sectionId.includes("quick-view") ||
                    sectionId.startsWith("shopify-section-sections--"); // 全局 sections

                  if (!shouldExclude && !isInMain) {
                    sectionsToMove.push(section);
                  }
                });

                if (sectionsToMove.length > 0) {
                  const mainSections = Array.from(
                    main.querySelectorAll('[id^="shopify-section-"]')
                  );
                  const mainSection = mainSections.find((s) =>
                    s.id.includes("__main")
                  );

                  sectionsToMove.forEach((section, index) => {
                    const sectionId = section.id;
                    movedCount++;

                    if (mainSection) {
                      if (index === 0) {
                        mainSection.insertAdjacentElement("afterend", section);
                      } else {
                        const previousSection = sectionsToMove[index - 1];
                        if (main.contains(previousSection)) {
                          previousSection.insertAdjacentElement(
                            "afterend",
                            section
                          );
                        } else {
                          mainSection.insertAdjacentElement(
                            "afterend",
                            section
                          );
                        }
                      }
                    } else {
                      main.appendChild(section);
                    }
                  });
                }
                if (movedCount > 0) {
                }
              } else {
              }
            }, 200);
            if (!variant) {
              this.setUnavailable();
              return;
            }
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;

          const { product } = getProductData(this);
          this.productJson = product || null;

          this.renderPrice(this.currentVariant);
          this.renderBuyButton(this.currentVariant);
          this.syncVariantId(this.currentVariant?.id);
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return async (html) => {
          const quickView = html.querySelector(
            "#MainProduct-quick-view__content"
          );
          if (quickView && viewMode === "quick-view") {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          await this.updateOptionValues(html);

          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          const updateSourceFromDestination = (
            id,
            shouldHide = (_s) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("Sku");
          updateSourceFromDestination("Inventory");
          updateSourceFromDestination("Badges");
          updateSourceFromDestination("PricePerItem");
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("QuantityRules");
          updateSourceFromDestination("VolumeNote");
          updateSourceFromDestination("custom-price");
          updateSourceFromDestination("TotalPriceRow");

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(
            `ProductSubmitButton-${this.sectionId}`
          );
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
            FoxTheme.variantStrings.soldOut
          );

          const stickyAtcBar = document.getElementById(
            `shopify-section-sticky-atc-bar`
          );
          if (stickyAtcBar) stickyAtcBar.classList.remove("hidden");

          this.currentVariant = variant;
          this.renderPrice(variant);
          this.renderBuyButton(variant);
          this.syncVariantId(variant?.id);

          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
            {
              data: { sectionId: this.sectionId, html, variant },
            }
          );

          document.dispatchEvent(
            new CustomEvent("variant:changed", { detail: { variant } })
          );
        };
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
        if (optionValues.length)
          params.push(`option_values=${optionValues.join(",")}`);
        return `${url}?${params.join("&")}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            return new Promise(async (resolve) => {
              await callback(html);
              const cleanTargetId = cleanElementId(targetId);
              const targetElement = document.querySelector(`#${cleanTargetId}`);
              if (targetElement) {
                targetElement.focus();
              } else {
              }
              resolve();
            });
          })
          .catch((error) => {
            if (error.name !== "AbortError") {
            } else {
            }
          });
      }

      updateOptionValues(html) {
        return new Promise((resolve) => {
          const variantSelects = html.querySelector("variant-selects");
          if (variantSelects) {
            this.updateFormLabelsOnlyWithCallback(variantSelects, () => {
              resolve();
            });
          } else {
            resolve();
          }
        });
      }
      getClickedOptionIndex(target) {
        try {
          if (!target) return -1;
          const fieldset = target.closest("fieldset");
          if (!fieldset) return -1;
          const allFieldsets =
            this.variantSelectors.querySelectorAll("fieldset");

          const index = Array.from(allFieldsets).indexOf(fieldset);
          return index;
        } catch (error) {
          return -1;
        }
      }

      updateFormLabelsOnlyWithCallback(newVariantSelects, callback) {
        try {
          const fieldsets =
            this.variantSelectors?.querySelectorAll("fieldset") || [];
          const isLastAttribute =
            this.lastClickedOptionIndex === fieldsets.length - 1;

          if (!isLastAttribute) {
            HTMLUpdateUtility.viewTransition(
              this.variantSelectors,
              newVariantSelects,
              this.preProcessHtmlCallbacks,
              callback ? [callback] : []
            );
          } else {
            callback();
          }
          const currentVariantSelects = this.variantSelectors;
          const newLabels = newVariantSelects.querySelectorAll(
            "span[data-selected-swatch-value]"
          );
          newLabels.forEach((newLabel) => {
            const attributeValue = newLabel.getAttribute(
              "data-selected-swatch-value"
            );
            const currentLabel = currentVariantSelects.querySelector(
              `span[data-selected-swatch-value="${attributeValue}"]`
            );
            if (
              currentLabel &&
              newLabel.textContent !== currentLabel.textContent
            ) {
              currentLabel.textContent = newLabel.textContent;
              this.updateFormLabelAndInput(
                attributeValue,
                newLabel.textContent,
                currentLabel
              );
            }
          });
        } catch (error) {}
      }

      updateFormLabelsOnly(newVariantSelects) {
        try {
          const fieldsets =
            this.variantSelectors?.querySelectorAll("fieldset") || [];
          const isLastAttribute =
            this.lastClickedOptionIndex === fieldsets.length - 1;
          if (!isLastAttribute) {
            HTMLUpdateUtility.viewTransition(
              this.variantSelectors,
              newVariantSelects,
              this.preProcessHtmlCallbacks
            );
          }
          const currentVariantSelects = this.variantSelectors;
          const newLabels = newVariantSelects.querySelectorAll(
            "span[data-selected-swatch-value]"
          );
          newLabels.forEach((newLabel) => {
            const attributeValue = newLabel.getAttribute(
              "data-selected-swatch-value"
            );
            const currentLabel = currentVariantSelects.querySelector(
              `span[data-selected-swatch-value="${attributeValue}"]`
            );
            if (
              currentLabel &&
              newLabel.textContent !== currentLabel.textContent
            ) {
              currentLabel.textContent = newLabel.textContent;
              this.updateFormLabelAndInput(
                attributeValue,
                newLabel.textContent,
                currentLabel
              );
            }
          });
        } catch (error) {}
      }

      updateFormLabelAndInput(attributeName, newValue, formLabel) {
        try {
          const fieldset = this.variantSelectors.querySelector(
            `fieldset[class*="${attributeName.toLowerCase()}"]`
          );
          if (!fieldset) {
            return;
          }
          const checkedInput = fieldset.querySelector(
            'input[type="radio"]:checked'
          );
          if (!checkedInput) {
            return;
          }
          const targetInput = fieldset.querySelector(
            `input[type="radio"][value="${newValue}"]`
          );
          if (!targetInput) {
            const allInputs = fieldset.querySelectorAll('input[type="radio"]');
            const availableValues = Array.from(allInputs).map(
              (input) => input.value
            );
            return;
          }
          const cleanId = targetInput.id.replace(/\s+/g, "").trim();
          const targetLabel = fieldset.querySelector(`label[for="${cleanId}"]`);
          if (!targetLabel) {
            return;
          }
          if (targetInput !== checkedInput) {
            checkedInput.checked = false;
            checkedInput.removeAttribute("checked");
            targetInput.checked = true;
            targetInput.setAttribute("checked", "checked");
            const variantSelects = this.variantSelectors;
            if (
              variantSelects &&
              typeof variantSelects.handleVariantChange === "function"
            ) {
              variantSelects.handleVariantChange(
                new Event("change", { target: targetInput })
              );
            } else {
              targetInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          } else {
          }
        } catch (error) {}
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === "false") return;
        const currentUrl = new URL(window.location.href);
        const newUrl = new URL(url, window.location.origin);
        currentUrl.searchParams.forEach((value, key) =>
          newUrl.searchParams.set(key, value)
        );
        if (variantId) newUrl.searchParams.set("variant", variantId);
        else newUrl.searchParams.delete("variant");
        window.history.replaceState({}, "", newUrl.toString());
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          )
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = variantId ?? "";
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const isMediaGroupingEnabled = this.isMediaGroupingEnabled();
        console.log("isMediaGroupingEnabled", isMediaGroupingEnabled);
        if (isMediaGroupingEnabled) {
          this.updateMediaWithPreGrouping(variant);
        } else {
          const mediaGallery = document.querySelector("media-gallery");
          if (!mediaGallery) {
            return;
          }
          // mediaGallery.style.display = "block";
          mediaGallery.style.opacity = "1";
          this.updateMediaByVariantImageId(variant);
        }
      }

      updateMediaByVariantImageId(variant) {
        const imageId =
          variant?.image_id ||
          variant?.featured_media?.id ||
          variant?.featured_image?.id;
        if (!imageId) return;

        const mediaGallery = document.querySelector("media-gallery");
        if (!mediaGallery) return;

        const mediaItems = mediaGallery.querySelectorAll(
          ".product__media-item"
        );
        let targetIndex = -1;

        for (let i = 0; i < mediaItems.length; i++) {
          if (mediaItems[i].getAttribute("data-media-id") === String(imageId)) {
            targetIndex = i;
            break;
          }
        }

        if (targetIndex === -1) return;

        if (mediaGallery.sliderInstance?.slider) {
          mediaGallery.sliderInstance.slider.slideTo(targetIndex, 300);
        }
      }

      isMediaGroupingEnabled() {
        if (
          typeof window.templateMediaGroupingSettings !== "undefined" &&
          window.templateMediaGroupingSettings.enable_product_media_grouping ===
            true
        ) {
          return true;
        }

        if (
          typeof window.Shopify !== "undefined" &&
          window.Shopify.theme &&
          window.Shopify.theme.settings &&
          window.Shopify.theme.settings.enable_product_media_grouping === true
        ) {
          return true;
        }

        const metaTag = document.querySelector('meta[name="theme-settings"]');
        if (metaTag) {
          try {
            const settings = JSON.parse(metaTag.content);
            return settings.enable_product_media_grouping === true;
          } catch (e) {
            console.warn("Failed to parse theme settings from meta tag");
          }
        }

        return false;
      }
      updateMediaWithPreGrouping(variant) {
        try {
          if (
            !window.productMediaPreGrouping ||
            !window.productMediaPreGrouping.isInitialized
          ) {
            return false;
          }

          const combinationKey =
            window.productMediaPreGrouping.createCombinationKey(variant);
          if (!combinationKey) {
            return false;
          }

          const combination =
            window.productMediaPreGrouping.combinations[combinationKey];
          if (
            !combination ||
            !combination.media ||
            !Array.isArray(combination.media)
          ) {
            return false;
          }
          this.reRenderMediaGallery(combination.media);
          window.productMediaPreGrouping.currentCombination = combination;
          window.productMediaPreGrouping.lastProcessedVariantId = variant.id;

          this.dispatchMediaUpdateEvent(variant, combination.media);

          return true;
        } catch (error) {
          return false;
        }
      }

      reRenderMediaGallery(mediaData) {
        try {
          const mediaGallery = document.querySelector("media-gallery");
          if (!mediaGallery) {
            return;
          }

          if (!mediaData || mediaData.length === 0) {
            return;
          }

          this.renderMediaContent(mediaData);
          this.reInitializeSwiper();
        } catch (error) {}
      }

      renderMediaContent(mediaData) {
        const mediaGallery = this.querySelector(
          `[id^="Slider-Gallery-${this.dataset.section}"]`
        );
        try {
          if (!mediaGallery) {
            return;
          }

          mediaGallery.innerHTML = "";
          let html = "";

          mediaData.forEach((media, index) => {
            html += this.renderMediaItem(media, index);
          });

          mediaGallery.innerHTML = html;
          this.renderThumbnailContent(mediaData);
          this.reInitializeSwiper();
        } catch (error) {}
      }
      renderMediaItem(media, index) {
        const mediaId = media.id || `media-${index}`;
        const mediaType = media.media_type || "image";
        const mediaSrc = media.src || "";
        const mediaAlt = media.alt || "";
        const mediaWidth = media.width || 750;
        const mediaHeight = media.height || 750;
        const srcset = this.generateSrcset(mediaSrc);
        const sizes = this.generateSizes();
        let mediaContent = "";
        let mediaIcon = "";
        switch (mediaType) {
          case "image":
            mediaContent = `
              <img 
                src="${mediaSrc}" 
                alt="${mediaAlt}" 
                srcset="${srcset}" 
                width="${mediaWidth}" 
                height="${mediaHeight}" 
                loading="lazy" 
                is="image-lazy" 
                fetchpriority="low" 
                sizes="${sizes}" 
                class="loaded"
              >`;
            mediaIcon = `
              <span class="product__media-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-zoom icon--medium" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"></path>
                  <path d="M16.4434 16.4453L20.9997 21.0016"></path>
                </svg>
              </span>`;
            break;

          case "video":
            const posterImage = media.preview_image?.src
              ? `<img 
                src="${media.preview_image.src}" 
                alt="${mediaAlt}" 
                width="${mediaWidth}" 
                height="${mediaHeight}"
                loading="lazy" 
                is="image-lazy" 
                fetchpriority="low" 
                sizes="${sizes}" 
                class="loaded"
              >`
              : `<div class="placeholder-svg" style="width: ${mediaWidth}px; height: ${mediaHeight}px; background-color: rgba(var(--color-foreground), 0.03);"></div>`;

            const videoSources = media.sources
              ? media.sources
                  .map(
                    (source) =>
                      `<source src="${source.url}" type="${source.mime_type}">`
                  )
                  .join("")
              : `<source src="${mediaSrc}" type="video/mp4">`;

            mediaContent = `
              <video-element 
              autoplay
                class="media-wrapper"
                ${media.autoplay ? "autoplay" : ""}
                data-media-id="${mediaId}"
              >
                ${posterImage}
                <template>
                  <video
                    controls
                    preload="metadata"
                    poster="${media.preview_image?.src || ""}"
                    width="${mediaWidth}" 
                    height="${mediaHeight}"
                    class="loaded"
                    playsinline
                    muted
                    ${media.autoplay ? "autoplay" : ""}
                    ${media.loop ? "loop" : ""}
                  >
                    ${videoSources}
                  </video>
                </template>
                <button
                  type="button"
                  id="DeferredPoster-${mediaId}"
                  class="media__poster absolute top-0 left-0 w-full h-full"
                >
                  <span class="media__play-button absolute flex items-center justify-center rounded-full pointer-events-auto z-10 motion-reduce">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-play icon--2xl" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="5,3 19,12 5,21"></polygon>
                    </svg>
                  </span>
                </button>
              </video-element>`;
            mediaIcon = `
              <span class="product__media-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-play icon--medium" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="5,3 19,12 5,21"></polygon>
                </svg>
              </span>`;
            break;

          case "model":
            mediaContent = `
              <product-model 
                data-media-id="${mediaId}"
                class="loaded"
              ></product-model>`;
            mediaIcon = `
              <span class="product__media-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-cube icon--medium" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27,6.96 12,12.01 20.73,6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </span>`;
            break;

          default:
            mediaContent = `
              <img 
                src="${mediaSrc}" 
                alt="${mediaAlt}" 
                srcset="${srcset}" 
                width="${mediaWidth}" 
                height="${mediaHeight}" 
                loading="lazy" 
                is="image-lazy" 
                fetchpriority="low" 
                sizes="${sizes}" 
                class="loaded"
              >`;
            mediaIcon = `
              <span class="product__media-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-zoom icon--medium" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"></path>
                  <path d="M16.4434 16.4453L20.9997 21.0016"></path>
                </svg>
              </span>`;
        }

        return `
          <div 
            role="listitem" 
            tabindex="-1" 
            class="product__media-item swiper-slide ${
              index === 0 ? "swiper-slide-active" : ""
            }" 
            data-media-id="${mediaId}" 
            data-media-type="${mediaType}" 
            data-media-index="${index}" 
            data-src="${mediaSrc}" 
            data-pswp-width="${mediaWidth}" 
            data-pswp-height="${mediaHeight}" 
            data-swiper-slide-index="${index}" 
            style="width: 607px; margin-right: 10px;"
          >
            <div class="product__media-container blocks-radius media-type-${mediaType}" style="--aspect-ratio: ${
          mediaWidth / mediaHeight
        };">
              <motion-element data-motion="zoom-out-sm" class="product__media media-wrapper loaded" style="transform: scale(1);">
                ${mediaContent}
              </motion-element>
              ${mediaIcon}
              <button 
                class="product__media-zoom btn--inherit js-photoswipe--zoom" 
                type="button" 
                aria-haspopup="dialog" 
                data-media-id="${mediaId}" 
                data-media-type="${mediaType}" 
                data-media-index="${index}"
              >
                <span class="visually-hidden">
                  Open media ${index + 1} in modal
                </span>
              </button>
            </div>
          </div>`;
      }

      generateSrcset(src) {
        if (!src) return "";

        const widths = [400, 620, 690, 810, 980, 1240, 1380, 1620];
        return widths
          .map((width) => {
            const srcWithWidth = src.replace(/width=\d+/, `width=${width}`);
            return `${srcWithWidth} ${width}w`;
          })
          .join(", ");
      }

      generateSizes() {
        return "(max-width: 768px) calc(100vw - 3rem), calc(((min(1440px, 100vw) * 0.585) - 4.5rem) / 1)";
      }
      renderThumbnailContent(mediaData) {
        const thumbnailGallery = this.querySelector(
          `[id^="Slider-Thumbnails-${this.dataset.section}"]`
        );

        try {
          if (!thumbnailGallery) {
            return;
          }

          thumbnailGallery.innerHTML = "";
          let html = "";

          mediaData.forEach((media, index) => {
            html += this.renderThumbnailItem(media, index);
          });

          thumbnailGallery.innerHTML = html;

          this.reInitializeThumbnailSwiper();
        } catch (error) {}
      }

      renderThumbnailItem(media, index) {
        const mediaId = media.id || `media-${index}`;
        const mediaType = media.media_type || "image";
        const mediaSrc = media.preview_image?.src || media.src || "";
        const mediaAlt = media.alt || "";
        const mediaWidth = media.preview_image?.width || media.width || 150;
        const mediaHeight = media.preview_image?.height || media.height || 150;

        const thumbnailSrcset = this.generateThumbnailSrcset(mediaSrc);
        const thumbnailSizes = this.generateThumbnailSizes();
        let mediaBadge = "";
        switch (mediaType) {
          case "model":
            mediaBadge = `
              <span class="product__thumbs-badge" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-3d-model icon--small" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27,6.96 12,12.01 20.73,6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </span>`;
            break;

          case "video":
          case "external_video":
            mediaBadge = `
              <span class="product__thumbs-badge" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-video icon--small" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="5,3 19,12 5,21"></polygon>
                </svg>
              </span>`;
            break;

          default:
            mediaBadge = "";
        }
        return `
          <div 
            class="product__thumbs-item swiper-slide" 
            data-target="${mediaId}" 
            data-media-position="${index + 1}"
            data-media-index="${index}"
            data-media-type="${mediaType}"
          >
            <div class="product__thumbs-container medium-blocks-radius media-wrapper">
              <div class="product__thumbs-inner" style="--aspect-ratio: ${
                mediaWidth / mediaHeight
              }">
                <img 
                  src="${mediaSrc}" 
                  alt="${mediaAlt}" 
                  srcset="${thumbnailSrcset}" 
                  sizes="${thumbnailSizes}" 
                  loading="lazy" 
                  is="image-lazy" 
                  width="${mediaWidth}" 
                  height="${mediaHeight}"
                >
              </div>
              ${mediaBadge}
            </div>
          </div>`;
      }

      generateThumbnailSrcset(src) {
        if (!src) return "";
        const widths = [70, 100, 140, 150, 200, 300, 400];
        return widths
          .map((width) => {
            const srcWithWidth = src.replace(/width=\d+/, `width=${width}`);
            return `${srcWithWidth} ${width}w`;
          })
          .join(", ");
      }

      generateThumbnailSizes() {
        return "(max-width: 767px) calc((100vw - 30px) / 4), (max-width: 1023px) 70px, 150px";
      }
      updateThumbnailData(thumbnailElement, media, index) {
        try {
          thumbnailElement.dataset.mediaIndex = index;
          thumbnailElement.dataset.mediaType = media.media_type;
          thumbnailElement.dataset.target = media.id;

          const img = thumbnailElement.querySelector("img");
          if (img) {
            const thumbnailSrc = media.preview_image?.src || media.src;
            img.src = thumbnailSrc;
            img.alt = media.alt || "";
            img.loading = "lazy";
          }

          const badge = thumbnailElement.querySelector(
            ".product__thumbs-badge"
          );
          if (media.media_type === "image") {
            if (badge) {
              badge.remove();
            }
          } else {
            if (!badge) {
              const badgeHtml = this.generateMediaBadge(media.media_type);
              thumbnailElement
                .querySelector(".product__thumbs-container")
                .insertAdjacentHTML("beforeend", badgeHtml);
            }
          }
        } catch (error) {}
      }

      generateMediaBadge(mediaType) {
        switch (mediaType) {
          case "model":
            return `
              <span class="product__thumbs-badge" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-3d-model icon--small" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27,6.96 12,12.01 20.73,6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </span>`;

          case "video":
          case "external_video":
            return `
              <span class="product__thumbs-badge" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-video icon--small" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="5,3 19,12 5,21"></polygon>
                </svg>
              </span>`;

          default:
            return "";
        }
      }

      reInitializeThumbnailSwiper() {
        const mediaGallery = document.querySelector("media-gallery");
        if (!mediaGallery) {
          return;
        }

        try {
          if (
            mediaGallery.thumbsInstance &&
            typeof mediaGallery.thumbsInstance === "object"
          ) {
            mediaGallery.thumbsInstance.slider.destroy();
            mediaGallery.thumbsInstance = false;
          }

          if (typeof mediaGallery.initThumbsSlider === "function") {
            mediaGallery.initThumbsSlider();
          } else {
          }
        } catch (error) {}
      }

      reInitializeSwiper() {
        const mediaGallery = document.querySelector("media-gallery");
        if (!mediaGallery) {
          return;
        }
        // mediaGallery.style.display = "block";
        mediaGallery.style.opacity = "1";
        try {
          if (
            mediaGallery.sliderInstance &&
            typeof mediaGallery.sliderInstance === "object"
          ) {
            mediaGallery.sliderInstance.slider.destroy();
            mediaGallery.sliderInstance = false;
          }

          if (
            mediaGallery.thumbsInstance &&
            typeof mediaGallery.thumbsInstance === "object"
          ) {
            mediaGallery.thumbsInstance.slider.destroy();
            mediaGallery.thumbsInstance = false;
          }

          setTimeout(() => {
            if (typeof mediaGallery.init === "function") {
              mediaGallery.init();
            }

            if (typeof mediaGallery.initSlider === "function") {
              mediaGallery.initSlider();
            } else {
            }
          }, 100);
        } catch (error) {}
      }

      dispatchMediaUpdateEvent(variant, mediaData) {
        try {
          const event = new CustomEvent("media:updated", {
            detail: {
              variant: variant,
              mediaData: mediaData,
              sectionId: this.sectionId,
              timestamp: Date.now(),
            },
          });
          document.dispatchEvent(event);
        } catch (error) {}
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(
          `ProductShare-${this.dataset.section}`
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${variantId}`
        );
      }

      toggleAddButton(disable = true, text, _modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = this.decoded(text);
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = this.decoded(
            FoxTheme.variantStrings.addToCart
          );
        }
      }

      decoded(text) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = text;
        return tempDiv.textContent;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const ids = [
          `price-${this.dataset.section}`,
          `Inventory-${this.dataset.section}`,
          `Sku-${this.dataset.section}`,
          `Volume-${this.dataset.section}`,
        ];
        ids.forEach((id) =>
          document.getElementById(id)?.classList.add("hidden")
        );
        document
          .getElementById(`shopify-section-sticky-atc-bar`)
          ?.classList.add("hidden");
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();
        if (!this.hasAttribute("data-original-section")) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.quantityInput.addEventListener("change", () => {
          if (!this.currentVariant) return;
          this.renderPrice(this.currentVariant);
        });
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(
          FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
          { data: { sectionId: this.sectionId, productId: this.productId } }
        );
      }

      fetchQuantityRules() {
        const isCartPage =
          document.querySelector(".cart") ||
          document.querySelector("cart-drawer");
        if (isCartPage) {
          return;
        }

        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;
        this.querySelector(".quantity__rules-cart")?.classList.add(
          "btn--loading"
        );
        fetch(
          `${this.getAttribute(
            "data-url"
          )}?variant=${currentVariantId}&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(
              this.sectionId,
              this.productId,
              parsedHTML
            );
          })
          .catch((error) => {})
          .finally(() => {
            this.querySelector(".quantity__rules-cart")?.classList.remove(
              "btn--loading"
            );
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: { sectionId, productId, parsedHTML },
        });
        this.setQuantityBoundries();
      }

      getQty() {
        const input =
          this.quantityInput || this.querySelector(".quantity__input");
        const v = Number(input?.value || 1);
        return Number.isFinite(v) && v > 0 ? v : 1;
      }
      getWarrantyCents() {
        const checked = this.querySelector('input[name="warranty"]:checked');
        const cents =
          checked && checked.dataset.price ? Number(checked.dataset.price) : 0;
        return Number.isFinite(cents) ? cents : 0;
      }
      calcTotals(variant) {
        const q = this.getQty();
        const p = Number(variant?.price || this.productJson?.price || 0);
        const c = Number(
          variant?.compare_at_price || this.productJson?.compare_at_price || 0
        );
        const w = this.getWarrantyCents();
        const current = p * q;
        const compare = c ? c * q : 0;
        return { current, compare, warranty: w };
      }
      renderPrice(variant) {
        const totals = this.calcTotals(variant);

        const currentEl = this.querySelector("[data-current-price]");
        const compareEl = this.querySelector("[data-compare-price]");
        if (currentEl)
          currentEl.textContent = formatMoney(
            variant?.price ?? this.productJson?.price
          );
        if (compareEl) {
          const show =
            variant?.compare_at_price &&
            variant.compare_at_price > variant.price;
          compareEl.textContent = show
            ? formatMoney(variant.compare_at_price)
            : "";
          compareEl.style.display = show ? "" : "none";
        }

        const row = this.querySelector("[data-total-price-row]");
        if (row) {
          const rowCur = row.querySelector("[data-total-current]");
          const rowCmp = row.querySelector("[data-total-compare]");
          if (rowCur) rowCur.textContent = formatMoney(totals.current);
          if (rowCmp) {
            const showCmp = totals.compare && totals.compare > totals.current;
            rowCmp.textContent = showCmp ? formatMoney(totals.compare) : "";
            rowCmp.style.display = showCmp ? "" : "none";
          }
        }

        const warrantyEl = this.querySelector("[data-warranty-price]");
        if (warrantyEl) {
          warrantyEl.textContent = totals.warranty
            ? `+ ${formatMoney(totals.warranty)}`
            : "";
        }
      }
      renderBuyButton(variant) {
        const disabled = !variant || !variant.available;
        this.toggleAddButton(
          disabled,
          disabled ? FoxTheme.variantStrings.soldOut : null
        );
      }
      syncVariantId(variantId) {
        const hidden = this.querySelector("input.product-variant-id");
        if (hidden && variantId) hidden.value = variantId;
      }
      getInitialVariant() {
        const urlVid = new URL(window.location.href).searchParams.get(
          "variant"
        );
        const hidden = this.querySelector("input.product-variant-id")?.value;
        const { product } = getProductData(this);
        this.productJson = product || this.productJson;

        const fromUrl = urlVid
          ? findVariantById(this.productJson, urlVid)
          : null;
        if (fromUrl) return fromUrl;

        return (
          findVariantById(this.productJson, hidden) ||
          this.productJson?.variants?.find((v) => v.available) ||
          this.productJson?.variants?.[0] ||
          null
        );
      }
      bindTotalsListeners() {
        const qty =
          this.quantityInput || this.querySelector(".quantity__input");
        if (qty)
          qty.addEventListener(
            "change",
            () => this.currentVariant && this.renderPrice(this.currentVariant)
          );
        const warranties = this.querySelectorAll('input[name="warranty"]');
        warranties.forEach((r) =>
          r.addEventListener(
            "change",
            () => this.currentVariant && this.renderPrice(this.currentVariant)
          )
        );
      }
    }
  );
}

function initRatingBadgeScroll() {
  const specificBlocks = document.querySelectorAll(
    ".product__block--shopify\\:\\/\\/apps\\/judge-me-reviews\\/blocks\\/preview_badge"
  );

  specificBlocks.forEach((block) => {
    block.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const ratingWidget = document.querySelector(
        "#shopify-block-Ac1JOZVJCaXVvWjFxW__judge_me_reviews_review_widget_QaAWKt"
      );
      if (ratingWidget) {
        ratingWidget.scrollIntoView({ behavior: "smooth", block: "start" });
        ratingWidget.style.outline = "2px solid #CD2A23";
        ratingWidget.style.outlineOffset = "10px";
        setTimeout(() => {
          ratingWidget.style.outline = "";
          ratingWidget.style.outlineOffset = "";
        }, 3000);
      }
    });
    block.style.cursor = "pointer";
    block.addEventListener("mouseenter", function () {
      this.style.opacity = "0.8";
      this.style.transform = "scale(1.02)";
    });
    block.addEventListener("mouseleave", function () {
      this.style.opacity = "1";
      this.style.transform = "scale(1)";
    });
  });
}
document.addEventListener("DOMContentLoaded", initRatingBadgeScroll);
window.addEventListener("load", initRatingBadgeScroll);

function initDimensionScroll() {
  document.addEventListener("click", (event) => {
    const target = event.target.closest('[data-action="scroll-to-dimension"]');
    if (target) {
      event.preventDefault();

      const isMobile = isMobileDevice();

      if (isMobile && target.dataset.dimensionsPopup === "true") {
        showDimensionsPopup();
      } else {
        scrollToDimension();
      }
    }
  });
}

function isMobileDevice() {
  const isMobileWidth = window.innerWidth <= 768;

  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

  return isMobileWidth || (isMobileUA && isTouchDevice);
}

function getProductTitle() {
  try {
    const productTitle = document.querySelector(
      "h1.product__title, .product-title h1, [data-product-title], .product__heading h1"
    );
    return productTitle ? productTitle.textContent.trim() : "Product Name";
  } catch (error) {
    return "Product Name";
  }
}

function getVariantName(variant) {
  try {
    if (!variant) return "Default Variant";

    const variantOptions = [];
    if (variant.option1) variantOptions.push(variant.option1);
    if (variant.option2) variantOptions.push(variant.option2);
    if (variant.option3) variantOptions.push(variant.option3);

    return variantOptions.length > 0
      ? variantOptions.join(" / ")
      : "Default Variant";
  } catch (error) {
    console.error("Error getting variant name:", error);
    return "Default Variant";
  }
}

function getFormattedPrice(variant) {
  try {
    if (!variant) return { price: "", comparePrice: null };
    let currentPrice = "";
    let comparePrice = null;
    const priceElement = document.querySelector(
      "[data-price-current], .f-price-item--sale, .f-price-item--regular, .price__regular .price-item--regular, .product-price .price, [data-price], .price-item--regular"
    );
    if (priceElement) {
      currentPrice = priceElement.textContent.trim();
    } else if (variant.price) {
      const currencyElement = document.querySelector(
        "[data-currency], .currency"
      );
      const currency = currencyElement
        ? currencyElement.textContent.trim()
        : "USD";
      const formattedPrice = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
      }).format(variant.price / 100);
      currentPrice = formattedPrice;
    }

    const comparePriceElement = document.querySelector(
      "[data-price-original], .f-price-item--regular s, .price__sale .price-item--sale, .price-item--compare, [data-compare-price]"
    );
    if (comparePriceElement) {
      const sTag = comparePriceElement.querySelector("s");
      comparePrice = sTag
        ? sTag.textContent.trim()
        : comparePriceElement.textContent.trim();
    } else if (
      variant.compare_at_price &&
      variant.compare_at_price > variant.price
    ) {
      const currencyElement = document.querySelector(
        "[data-currency], .currency"
      );
      const currency = currencyElement
        ? currencyElement.textContent.trim()
        : "USD";

      const formattedComparePrice = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
      }).format(variant.compare_at_price / 100);
      comparePrice = formattedComparePrice;
    }

    return { price: currentPrice, comparePrice: comparePrice };
  } catch (error) {
    return { price: "", comparePrice: null };
  }
}

// 显示尺寸图弹窗
function showDimensionsPopup() {
  try {
    console.log("showDimensionsPopup called");

    let currentVariant = null;
    const productInfoContainer = document.querySelector("product-info");
    if (productInfoContainer && productInfoContainer.currentVariant) {
      currentVariant = productInfoContainer.currentVariant;
    }
    if (!currentVariant) {
      const variantSelects = document.querySelector("variant-selects");
      if (variantSelects && variantSelects.currentVariant) {
        currentVariant = variantSelects.currentVariant;
      }
    }

    if (
      !currentVariant &&
      window.mainProductManager &&
      window.mainProductManager.currentVariant
    ) {
      currentVariant = window.mainProductManager.currentVariant;
    }

    if (!currentVariant) {
      const variantIdInput = document.querySelector('input[name="id"]');
      if (variantIdInput && variantIdInput.value) {
        const productJsonEl = document.querySelector('[id^="ProductJson-"]');
        if (productJsonEl) {
          const product = JSON.parse(productJsonEl.textContent);
          currentVariant = product.variants.find(
            (v) => v.id === parseInt(variantIdInput.value)
          );
        }
      }
    }

    if (!currentVariant) {
      const mediaGallery = document.querySelector("media-gallery");
      if (mediaGallery) {
        const firstDimensionImg = mediaGallery.querySelector(
          'img[alt*="dimension"]'
        );
        if (firstDimensionImg) {
          const highResSrc = firstDimensionImg.src.replace(
            /width=\d+/,
            "width=1200"
          );
          if (window.dimensionsPopup) {
            window.dimensionsPopup.open(
              highResSrc,
              firstDimensionImg.alt || ""
            );
            return;
          }
        }
      }
      return;
    }

    const dimensionMedia = findDimensionMedia(currentVariant);
    if (!dimensionMedia) {
      return;
    }

    const img = dimensionMedia.querySelector("img");
    if (!img || !img.src) {
      return;
    }

    const highResSrc = img.src.replace(/width=\d+/, "width=1200");
    const priceInfo = getFormattedPrice(currentVariant);
    const productInfo = {
      title: getProductTitle(),
      variantName: getVariantName(currentVariant),
      price: priceInfo.price,
      comparePrice: priceInfo.comparePrice,
    };

    if (window.dimensionsPopup) {
      window.dimensionsPopup.open(highResSrc, img.alt || "尺寸图", productInfo);
    } else {
    }
  } catch (error) {}
}

function scrollToDimension() {
  try {
    const productInfoContainer = document.querySelector("product-info");
    if (!productInfoContainer || !productInfoContainer.currentVariant) {
      return;
    }

    const currentVariant = productInfoContainer.currentVariant;
    const dimensionMedia = findDimensionMedia(currentVariant);
    if (!dimensionMedia) {
      return;
    }

    scrollToMediaItem(dimensionMedia);
  } catch (error) {}
}

function findDimensionMedia(variant) {
  const dimensionAltTexts = getDimensionAltText(variant);
  const mediaGallery = document.querySelector("media-gallery");
  if (!mediaGallery) {
    return null;
  }

  const mediaItems = mediaGallery.querySelectorAll(".product__media-item");
  for (let mediaItem of mediaItems) {
    const img = mediaItem.querySelector("img");
    if (img && img.alt) {
      const altText = img.alt.trim().toLowerCase().replace(/\s+/g, "-");

      if (
        altText === dimensionAltTexts.fullAttribute ||
        (dimensionAltTexts.comboAttribute &&
          altText === dimensionAltTexts.comboAttribute)
      ) {
        return mediaItem;
      }
    }
  }

  return null;
}

function getDimensionAltText(variant) {
  if (!variant) return { fullAttribute: "", comboAttribute: "" };

  const combinationKey = createCombinationKey(variant);
  const comboAttribute = getComboAttribute(variant);

  const fullAttributeDimension = combinationKey + "-dimension";
  const comboAttributeDimension = comboAttribute
    ? comboAttribute + "-dimension"
    : null;

  return {
    fullAttribute: fullAttributeDimension,
    comboAttribute: comboAttributeDimension,
  };
}

function createCombinationKey(variant) {
  if (variant.options && variant.options.length > 0) {
    const combinationKey = variant.options
      .map((option) => {
        let optionValue = option;

        if (option.includes("|")) {
          optionValue = option.split("|")[0].trim();
        }

        if (/^\d+$/.test(optionValue)) {
          return null;
        }

        return optionValue.toLowerCase().replace(/\s+/g, "-");
      })
      .filter((option) => option && option.length > 0)
      .join("-");

    return combinationKey;
  }

  const options = [];
  if (variant.option1) options.push(variant.option1);
  if (variant.option2) options.push(variant.option2);
  if (variant.option3) options.push(variant.option3);

  if (options.length === 0) {
    return "default";
  }

  const combinationKey = options
    .map((option) => {
      let optionValue = option;

      if (option.includes("|")) {
        optionValue = option.split("|")[0].trim();
      }

      if (/^\d+$/.test(optionValue)) {
        return null;
      }

      return optionValue.toLowerCase().replace(/\s+/g, "-");
    })
    .filter((option) => option && option.length > 0)
    .join("-");

  return combinationKey;
}

function getComboAttribute(variant) {
  if (variant.options && variant.options.length > 0) {
    const comboOption = variant.options[variant.options.length - 1];
    const optionValue = comboOption.includes("|")
      ? comboOption.split("|")[0].trim()
      : comboOption;
    return optionValue.toLowerCase().replace(/\s+/g, "-");
  }

  if (variant.option3) {
    const optionValue = variant.option3.includes("|")
      ? variant.option3.split("|")[0].trim()
      : variant.option3;
    return optionValue.toLowerCase().replace(/\s+/g, "-");
  }

  return null;
}

function scrollToMediaItem(mediaItem) {
  const mediaGallery = document.querySelector("media-gallery");
  if (
    mediaGallery &&
    mediaGallery.sliderInstance &&
    mediaGallery.sliderInstance.slider
  ) {
    const swiper = mediaGallery.sliderInstance.slider;
    const mediaIndex = parseInt(mediaItem.dataset.mediaIndex) || 0;

    if (typeof swiper.slideToLoop === "function") {
      swiper.slideToLoop(mediaIndex, 300, false);
      return;
    }

    if (typeof swiper.slideTo === "function") {
      swiper.slideTo(mediaIndex, 300, false);
      return;
    }
  }

  const scrollableContainer = findScrollableContainer();
  if (scrollableContainer && mediaItem) {
    const mediaIndex = parseInt(mediaItem.dataset.mediaIndex) || 0;
    const scrollLeft = mediaIndex * scrollableContainer.clientWidth;

    scrollableContainer.scrollTo({
      left: scrollLeft,
      behavior: "smooth",
    });
    return;
  }

  if (mediaItem) {
    mediaItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }
}

function findScrollableContainer() {
  const mediaList = document.querySelector(".product__media-list");
  if (mediaList) {
    return mediaList;
  }

  const swiperContainer = document.querySelector(".swiper-wrapper");
  if (swiperContainer) {
    return swiperContainer;
  }

  const mediaGallery = document.querySelector(".product__media-gallery-viewer");
  if (mediaGallery) {
    return mediaGallery;
  }

  return null;
}

document.addEventListener("DOMContentLoaded", initDimensionScroll);
window.addEventListener("load", initDimensionScroll);
setTimeout(() => {
  initDimensionScroll();
}, 1000);

// 移动端获取并设置 product-motion-element 高度
function calculateAndSetProductMotionElementHeight() {
  try {
    // 检测是否为移动端
    if (!isMobileDevice()) {
      return;
    }

    const productMotionElement = document.getElementById(
      "product-motion-element"
    );
    if (!productMotionElement) {
      return;
    }

    // 获取当前元素的高度
    const currentHeight = productMotionElement.offsetHeight;

    // 应用高度
    productMotionElement.style.height = `${currentHeight}px`;
  } catch (error) {
    console.error("Error getting product motion element height:", error);
  }
}

// 页面加载完成后执行高度计算
document.addEventListener("DOMContentLoaded", () => {
  // 延迟执行，确保所有元素都已渲染
  setTimeout(calculateAndSetProductMotionElementHeight, 100);
});

// 窗口大小变化时重新计算高度
window.addEventListener("resize", () => {
  // 使用防抖，避免频繁计算
  clearTimeout(window.productMotionHeightTimeout);
  window.productMotionHeightTimeout = setTimeout(
    calculateAndSetProductMotionElementHeight,
    150
  );
});

// 页面完全加载后再次执行
window.addEventListener("load", () => {
  setTimeout(calculateAndSetProductMotionElementHeight, 200);
});

// 方向变化时重新计算（移动端横竖屏切换）
window.addEventListener("orientationchange", () => {
  setTimeout(calculateAndSetProductMotionElementHeight, 300);
});
